module.exports = __webpack_public_path__ + "static/media/feature_4_0.b8153f88.jpg";